export const mappingOptions = {
  byFirstNameAndLastName: "firstNameAndLastName",
  byName: "name",
  byFrontendName: "frontendName",
  byBenefit: "benefit",
  byTemplateName: "templateName",
  byFirstNameLastNameUsername: "firstNameLastNameUsername",
  byFullName: "fullName",
};

export const mappingAsOption = (IRI_PREFIX) => ({
  [mappingOptions.byFirstNameAndLastName]: ({ firstName, lastName, id }) => ({
    value: id,
    label: `${firstName} ${lastName}`,
  }),
  [mappingOptions.byName]: ({ name, id }) => ({ value: id, label: name }),
  [mappingOptions.byFrontendName]: ({ frontendName, id }) => ({
    value: id,
    label: frontendName,
  }),
  [mappingOptions.byBenefit]: ({
    name,
    id,
    benefitEmployeeGroups,
    benefitSubgroup,
  }) => ({
    value: id,
    label: name,
    benefitEmployeeGroups,
    benefitSubgroup,
  }),
  [mappingOptions.byTemplateName]: ({ name, id }) => ({
    value: `${IRI_PREFIX}/${id}`,
    label: name || "Szablon bez nazwy",
  }),
  [mappingOptions.byFirstNameLastNameUsername]: ({
    id,
    firstName,
    lastName,
    username,
  }) => ({
    value: id,
    label: `${firstName} ${lastName} (${username})`,
  }),
  [mappingOptions.byFullName]: ({ fullName, id }) => ({
    value: id,
    label: fullName,
  }),
});

const modifyResponse = ({
  resData,
  idAsIri,
  asOption,
  benefitSubgroupId,
  IRI_PREFIX,
  mappingType = mappingOptions.byName,
}) => {
  let result = resData;
  if (idAsIri) {
    result = result.map((el) => ({
      ...el,
      id: `${IRI_PREFIX}/${el.id}`,
    }));
  }
  if (asOption) {
    result = result.map(mappingAsOption(IRI_PREFIX)[mappingType]);
  }
  if (benefitSubgroupId) {
    result = [
      result[0]?.benefitSubgroups?.find(
        (subgroup) => subgroup.id === benefitSubgroupId
      ),
    ];
  }

  return result;
};

export default modifyResponse;
